import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const nav = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Process", href: "#process" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const linkPrefix = pathname === "/" ? "" : "/";

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-[#E2E8F0]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-3">
          <img
            src="/logo.png"
            alt="SHUNYA CDC — Where Everything Begins"
            className="h-11 w-11 object-contain"
          />
          <div className="leading-tight">
            <div className="font-heading font-bold text-[#0A192F] tracking-tight">
              SHUNYA <span className="text-[#0055FF]">CDC</span>
            </div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#0055FF]">
              Where Everything Begins
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {nav.map((n) => (
            <a
              key={n.href}
              href={`${linkPrefix}${n.href}`}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="px-3 py-2 text-sm text-[#475569] hover:text-[#0A192F] hover:bg-[#F8FAFC] rounded-md transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <Link
            to="/book"
            data-testid="header-book-btn"
            className="inline-flex items-center bg-[#0055FF] text-white hover:bg-[#0044CC] rounded-full px-5 py-2.5 font-medium text-sm transition-colors"
          >
            Book Consultation
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 rounded-md border border-[#E2E8F0]"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E2E8F0] bg-white">
          <div className="px-4 py-3 flex flex-col gap-1">
            {nav.map((n) => (
              <a
                key={n.href}
                href={`${linkPrefix}${n.href}`}
                data-testid={`nav-mobile-${n.label.toLowerCase()}`}
                onClick={() => setOpen(false)}
                className="px-3 py-2 rounded-md text-[#0F172A] hover:bg-[#F8FAFC]"
              >
                {n.label}
              </a>
            ))}
            <Link
              to="/book"
              data-testid="header-mobile-book-btn"
              className="mt-2 inline-flex items-center justify-center bg-[#0055FF] text-white rounded-full px-5 py-2.5 font-medium"
              onClick={() => setOpen(false)}
            >
              Book Consultation
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
